  window.onload = function () {
    const targetOption = document.querySelector('[data-vtitle="pack-of-2"]');
    if (targetOption) {
      targetOption.click();
    }
  };

    $(document).ready(function () {
    $('.copy-btn').click(function () {
      const code = $(this).data('code');
      navigator.clipboard.writeText(code);

      const $text = $(this).find('.copy-text');
      const originalText = $text.text();
      $text.text('COPIED');

      setTimeout(() => {
        $text.text(originalText);
      }, 3000);
    });
  });





  const PUBLIC_KEY = "DlsouVX7gvYUH83xeCTZ";
  const PRIVATE_KEY = "KGm89UsRkwvWNpSHV15t";
  const PICKUP_PINCODE = 122001;

  $('#checkBtn').on('click', function () {
    const pincode = $('#pincodeInput').val().trim();
    const errorEl = $('#errorMessage');
    const messageEl = $('#deliveryMessage');
    errorEl.text('');
    messageEl.text('');

    if (!/^\d{6}$/.test(pincode)) {
      errorEl.text('Please enter a valid pincode');
      return;
    }

    $.ajax({
      url: "https://shipping-api.com/app/api/v1/pincode-serviceability",
      method: "POST",
      headers: {
        "public-key": PUBLIC_KEY,
        "private-key": PRIVATE_KEY,
        "Content-Type": "application/json"
      },
      data: JSON.stringify({
        pickup_pincode: PICKUP_PINCODE,
        delivery_pincode: parseInt(pincode)
      }),
      success: function (res) {
        if (res.result === "1" && res.data.serviceable) {
          const date = new Date();
          date.setDate(date.getDate() + 7);
          const options = { weekday: 'long', month: 'long', day: 'numeric' };
          const formattedDate = date.toLocaleDateString('en-US', options);

          messageEl.html(`<p>Expected Delivery:</p> <strong>${formattedDate}</strong>`);
          $('.delivery-icon').show();
        } else {
          errorEl.text('Please enter a valid pincode');
          $('.delivery-icon').hide();
        }
      },
      error: function () {
        errorEl.text('Please try again.');
      }
    });
  });



// Previous button
document.querySelector('[is="prev-button"]').addEventListener('click', () => {
  document.querySelector('media-carousel').previous();
});

// Next button
document.querySelector('[is="next-button"]').addEventListener('click', () => {
  document.querySelector('media-carousel').next();
});





// carousel-dots.js
document.addEventListener('DOMContentLoaded', function() {
  function initCarouselDots() {
    const carousels = document.querySelectorAll('scroll-carousel');
    
    carousels.forEach(carousel => {
      const container = carousel.closest('.scrollable-with-controls');
      if (!container) return;
      
      let dotsContainer = container.querySelector('.mobile-dots');
      const slides = carousel.querySelectorAll('.testimonial-card, .new_testimonial, .gutrepair-card, .pdp_icons_block, .product-card');
      
      if (!dotsContainer && slides.length > 1) {
        dotsContainer = document.createElement('div');
        dotsContainer.className = 'mobile-dots md:hidden flex justify-center gap-2 mt-4';
        
        // Add dots as buttons instead of divs
        slides.forEach((_, index) => {
          const dot = document.createElement('button'); // Changed to button
          dot.className = 'dot w-3 h-3 rounded-full bg-gray-300 transition-colors';
          dot.setAttribute('type', 'button'); // Add type attribute
          dot.setAttribute('data-index', index);
          dot.setAttribute('aria-label', `Go to slide ${index + 1}`); // Better accessibility
          if (index === 0) dot.setAttribute('aria-current', 'true');
          
          const srText = document.createElement('span');
          srText.className = 'sr-only';
          srText.textContent = `Slide ${index + 1}`;
          
          dot.appendChild(srText);
          dotsContainer.appendChild(dot);
        });
        
        container.appendChild(dotsContainer);
      }
      
      // Initialize dots functionality
      if (dotsContainer && slides.length > 1) {
        const dots = dotsContainer.querySelectorAll('.dot');
        
        function updateDots() {
          const containerCenter = carousel.getBoundingClientRect().left + carousel.getBoundingClientRect().width / 2;
          let closestIndex = 0;
          let smallestDistance = Infinity;
          
          slides.forEach((slide, index) => {
            const slideRect = slide.getBoundingClientRect();
            const slideCenter = slideRect.left + slideRect.width / 2;
            const distance = Math.abs(slideCenter - containerCenter);
            
            if (distance < smallestDistance) {
              smallestDistance = distance;
              closestIndex = index;
            }
          });
          
          dots.forEach((dot, index) => {
            const isActive = index === closestIndex;
            dot.setAttribute('aria-current', isActive);
            dot.style.backgroundColor = isActive ? '#0D9F98' : '#AAAAAA';
          });
        }
        
        // Make dots clickable
        dots.forEach(dot => {
          dot.addEventListener('click', function() {
            const index = parseInt(this.getAttribute('data-index'));
            const slide = slides[index];
            
            if (slide) {
              // Calculate scroll position to center the slide
              const slideRect = slide.getBoundingClientRect();
              const carouselRect = carousel.getBoundingClientRect();
              const scrollTo = slide.offsetLeft - (carouselRect.width / 2 - slideRect.width / 2);
              
              carousel.scrollTo({
                left: scrollTo,
                behavior: 'smooth'
              });
            }
          });
        });
        
        updateDots();
        
        let scrollTimeout;
        carousel.addEventListener('scroll', () => {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(updateDots, 100);
        });
        
        window.addEventListener('resize', updateDots);
      }
    });
  }
  
  setTimeout(initCarouselDots, 500);
});











// Add this to your theme.js or create a new file
document.addEventListener('DOMContentLoaded', function() {
  // Initialize product gallery dots
  function initProductGalleryDots() {
    const galleryContainers = document.querySelectorAll('product-gallery');
    
    galleryContainers.forEach(gallery => {
      const mediaCarousel = gallery.querySelector('media-carousel');
      if (!mediaCarousel) return;
      
      // Create dots container if it doesn't exist
      let dotsContainer = gallery.querySelector('.mobile-dots');
      if (!dotsContainer) {
        dotsContainer = document.createElement('div');
        dotsContainer.className = 'mobile-dots md:hidden flex justify-center gap-2 mt-4';
        gallery.appendChild(dotsContainer);
      }
      
      // Get all media items (excluding hidden ones)
      const mediaItems = Array.from(mediaCarousel.querySelectorAll('.product-gallery__media:not([hidden])'));
      if (mediaItems.length <= 1) return;
      
      // Clear existing dots
      dotsContainer.innerHTML = '';
      
      // Create dots
      mediaItems.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.className = 'dot w-3 h-3 rounded-full bg-gray-300 transition-colors';
        dot.setAttribute('type', 'button');
        dot.setAttribute('data-index', index);
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dotsContainer.appendChild(dot);
      });
      
      const dots = Array.from(dotsContainer.querySelectorAll('.dot'));
      
      // Update active states
      function updateActiveStates() {
        const scrollCenter = mediaCarousel.scrollLeft + mediaCarousel.clientWidth / 2;
        
        let closestIndex = 0;
        let smallestDistance = Infinity;
        
        mediaItems.forEach((item, index) => {
          const itemRect = item.getBoundingClientRect();
          const itemCenter = itemRect.left + itemRect.width / 2 - mediaCarousel.getBoundingClientRect().left + mediaCarousel.scrollLeft;
          const distance = Math.abs(itemCenter - scrollCenter);
          
          if (distance < smallestDistance) {
            smallestDistance = distance;
            closestIndex = index;
          }
        });
        
        dots.forEach((dot, index) => {
          const isActive = index === closestIndex;
          dot.setAttribute('aria-current', isActive);
          dot.style.backgroundColor = isActive ? '#0D9F98' : '#AAAAAA';
        });
      }
      
      // Make dots clickable
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const item = mediaItems[index];
          const scrollTo = item.offsetLeft - (mediaCarousel.clientWidth / 2 - item.offsetWidth / 2);
          
          mediaCarousel.scrollTo({
            left: scrollTo,
            behavior: 'smooth'
          });
        });
      });
      
      // Initialize
      updateActiveStates();
      
      // Update on scroll
      let scrollTimeout;
      mediaCarousel.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateActiveStates, 100);
      });
      
      // Update on resize
      window.addEventListener('resize', updateActiveStates);
    });
  }
  
  // Wait for everything to load
  setTimeout(initProductGalleryDots, 500);
});